import React, { createContext, useContext, useState, useEffect } from 'react';

const BasketContext = createContext();

export const useBasket = () => {
  const context = useContext(BasketContext);
  if (!context) {
    throw new Error('useBasket must be used within a BasketProvider');
  }
  return context;
};

export const BasketProvider = ({ children }) => {
  const [basket, setBasket] = useState(() => {
    const savedBasket = localStorage.getItem('basket');
    return savedBasket ? JSON.parse(savedBasket) : null;
  });
  const [expiry, setExpiry] = useState(() => {
    const savedExpiry = localStorage.getItem('basketExpiry');
    return savedExpiry ? parseInt(savedExpiry, 10) : null;
  });

  useEffect(() => {
    localStorage.setItem('basket', JSON.stringify(basket));
  }, [basket]);

  useEffect(() => {
    if (expiry) {
      localStorage.setItem('basketExpiry', expiry.toString());
    } else {
      localStorage.removeItem('basketExpiry');
    }
  }, [expiry]);

  const addToBasket = (item) => {
    setBasket(item);
    // If basket is being created for the first time, set expiry to 30 minutes from now
    if (!expiry) {
      const newExpiry = Date.now() + 10 * 60 * 1000;
      setExpiry(newExpiry);
    }
  };

  const removeFromBasket = (itemId) => {
    setBasket(null);
    setExpiry(null);
  };

  const clearBasket = () => {
    setBasket([]);
    setExpiry(null);
  };

  const clearExpiry = () => {
    setExpiry(null);
  };

  const value = {
    basket,
    addToBasket,
    removeFromBasket,
    clearBasket,
    expiry,
    clearExpiry
  };

  return (
    <BasketContext.Provider value={value}>
      {children}
    </BasketContext.Provider>
  );
}; 